import basePath from "base_path";

import ActionTypes from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";

import rateLimit, {getStandardTimeout} from "utils/rate_limit";
import {createChangeTimeWrapper} from "utils/ensure_fresh_update";

function doSave(
  requestor,
  organisationId,
  topicId,
  topicparameterId,
  data,
  changeTime,
) {
  return requestor
    .patch(
      `${basePath}/organisation/${organisationId}/topic/${topicId}` +
        `/parameter/${topicparameterId}`,
      data,
      {withCredentials: true},
    )
    .then(response => ({
      ...createChangeTimeWrapper(changeTime),
      ...response.data,
    }));
}

const save = rateLimit(doSave, getStandardTimeout());

export default function updateTopicParameter(requestor) {
  const action = createReduxPromiseAction(
    ActionTypes.TOPICPARAMETER_UPDATE,
    (organisationId, topicId, topicparameterId, data, changeTime) => {
      if (!data.last_edited) {
        throw new Error("data must contain a last_edited key");
      }

      return save(
        requestor,
        organisationId,
        topicId,
        topicparameterId,
        data,
        changeTime,
      );
    },
    (organisationId, topicId, topicparameterId, data, changeTime) => ({
      ...createChangeTimeWrapper(changeTime),
      id: topicparameterId,
      topic_id: topicId,
      ...data,
    }),
  );

  return action;
}
